/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Box,
  Typography,
  Paper,
  Grid,
  Chip,
  IconButton,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import {
  PhotoCamera,
  Close as CloseIcon,
  CheckCircle,
  Cancel,
} from "@material-ui/icons";

// Importar las imágenes
import CorrectoImg from "src/assets/img/Correcto.png";
import IncorrectoImg from "src/assets/img/Incorrecto.png";

const InformativeDialog = ({ open, onClose, onContinue, isEditing }) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  // Sincronizar el estado del checkbox con localStorage cuando se abre el diálogo
  useEffect(() => {
    if (open) {
      const isHidden = localStorage.getItem('hideFaceInstructions') === 'true';
      setDontShowAgain(isHidden);
    }
  }, [open]);

  const handleCheckboxChange = (e) => {
    const {checked} = e.target;
    setDontShowAgain(checked);
    
    // Actualizar localStorage inmediatamente
    if (checked) {
      localStorage.setItem('hideFaceInstructions', 'true');
    } else {
      localStorage.removeItem('hideFaceInstructions');
    }
  };

  const handleContinue = () => {
    onContinue();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle style={{ backgroundColor: "#092147", color: "white" }}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" style={{ fontWeight: "600" }}>
            Instrucciones para Captura de Rostro
          </Typography>
          <IconButton onClick={handleClose} style={{ color: "white" }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent style={{ padding: "24px" }}>
        <Box mb={3}>
          <Typography variant="body2" color="textSecondary" paragraph>
            Para un registro biométrico exitoso, necesitamos capturar el rostro
            correctamente. A continuación te mostramos ejemplos:
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {/* Imagen Izquierda - CORRECTO */}
          <Grid item xs={12} md={6}>
            <Paper
              elevation={3}
              style={{
                padding: "16px",
                textAlign: "center",
                backgroundColor: "#f0fdf4",
                border: "3px solid #10b981",
              }}
            >
              <Box
                style={{
                  width: "100%",
                  height: "300px",
                  backgroundColor: "#dcfce7",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "16px",
                  border: "2px solid #10b981",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <img
                  src={CorrectoImg}
                  alt="Ejemplo Correcto"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                  }}
                />
                <Box
                  style={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    backgroundColor: "#10b981",
                    borderRadius: "50%",
                    padding: "4px",
                  }}
                >
                  <CheckCircle style={{ color: "white", fontSize: 32 }} />
                </Box>
              </Box>
              <Chip
                icon={<CheckCircle style={{ color: "white" }} />}
                label="✓ CORRECTO"
                style={{
                  backgroundColor: "#10b981",
                  color: "white",
                  fontWeight: "bold",
                  marginBottom: "8px",
                  fontSize: "14px",
                }}
              />
              <Typography
                variant="body2"
                style={{ marginTop: "8px", fontWeight: "600", color: "#065f46" }}
              >
                ✓ Rostro de frente
              </Typography>
              <Typography variant="body2" style={{ color: "#065f46" }}>
                ✓ Fondo Blanco
              </Typography>
              <Typography variant="body2" style={{ color: "#065f46" }}>
                ✓ Sin maquillaje
              </Typography>
              <Typography variant="body2" style={{ color: "#065f46" }}>
                ✓ Sin gafas o lentes
              </Typography>
              <Typography variant="body2" style={{ color: "#065f46" }}>
                ✓ Sin cuerpo completo
              </Typography>
            </Paper>
          </Grid>

          {/* Imagen Derecha - INCORRECTO */}
          <Grid item xs={12} md={6}>
            <Paper
              elevation={3}
              style={{
                padding: "16px",
                textAlign: "center",
                backgroundColor: "#fef2f2",
                border: "3px solid #ef4444",
              }}
            >
              <Box
                style={{
                  width: "100%",
                  height: "300px",
                  backgroundColor: "#fee2e2",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "16px",
                  border: "2px solid #ef4444",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <img
                  src={IncorrectoImg}
                  alt="Ejemplo Incorrecto"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                  }}
                />
                <Box
                  style={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    backgroundColor: "#ef4444",
                    borderRadius: "50%",
                    padding: "4px",
                  }}
                >
                  <Cancel style={{ color: "white", fontSize: 32 }} />
                </Box>
              </Box>
              <Chip
                icon={<Cancel style={{ color: "white" }} />}
                label="✗ INCORRECTO"
                style={{
                  backgroundColor: "#ef4444",
                  color: "white",
                  fontWeight: "bold",
                  marginBottom: "8px",
                  fontSize: "14px",
                }}
              />
              <Typography
                variant="body2"
                style={{ marginTop: "8px", fontWeight: "600", color: "#991b1b" }}
              >
                ✗ Imagen con fondo
              </Typography>
              <Typography variant="body2" style={{ color: "#991b1b" }}>
                ✗ Cuerpo completo
              </Typography>
              <Typography variant="body2" style={{ color: "#991b1b" }}>
                ✗ Accesorios que cubren el rostro
              </Typography>
              <Typography variant="body2" style={{ color: "#991b1b" }}>
                ✗ Imagenes largas
              </Typography>
              <Typography variant="body2" style={{ color: "#991b1b" }}>
                ✗ Calidad de imagen baja
              </Typography>
              <Typography variant="body2" style={{ color: "#991b1b" }}>
                ✗ Imagen con maquillaje
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        <Box
          mt={3}
          p={2}
          style={{
            backgroundColor: "#fef3c7",
            borderRadius: "8px",
            border: "1px solid #f59e0b",
          }}
        >
          <Typography
            variant="body2"
            style={{ color: "#92400e", fontWeight: "600" }}
          >
            ⚠️ Recomendaciones Importantes:
          </Typography>
          <Typography
            variant="body2"
            style={{ color: "#92400e", marginTop: "8px" }}
          >
            • La imagen debe ser de buena calidad y nítida
          </Typography>
          <Typography variant="body2" style={{ color: "#92400e" }}>
            • Fondo neutro y sin distracciones
          </Typography>
          <Typography variant="body2" style={{ color: "#92400e" }}>
            • Sin gafas de sol ni accesorios que cubran el rostro
          </Typography>
          <Typography variant="body2" style={{ color: "#92400e" }}>
            • Calidad de imagen: mínimo 800x600 píxeles
          </Typography>
          <Typography variant="body2" style={{ color: "#92400eo" }}>
            • Formato: JPG, PNG (máximo 1MB)
          </Typography>
          <Typography variant="body2" style={{ color: "#92400e" }}>
            • Iluminación uniforme sin sombras pronunciadas
          </Typography>
        </Box>

        {isEditing && (
          <Box
            mt={2}
            p={2}
            style={{
              backgroundColor: "#dbeafe",
              borderRadius: "8px",
              border: "1px solid #3b82f6",
            }}
          >
            <Typography
              variant="body2"
              style={{ color: "#1e40af", fontWeight: "600" }}
            >
              ℹ️ Modo Edición:
            </Typography>
            <Typography
              variant="body2"
              style={{ color: "#1e40af", marginTop: "8px" }}
            >
              Si deseas actualizar la imagen del rostro, asegúrate de capturar
              una fotografía siguiendo las indicaciones de la imagen CORRECTA
              mostrada arriba.
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions
        style={{
          padding: "16px 24px",
          backgroundColor: "#f8fafc",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={dontShowAgain}
              onChange={handleCheckboxChange}
              color="primary"
            />
          }
          label={
            <Box>
              <Typography variant="body2" style={{ color: "#64748b", fontWeight: 600 }}>
                {dontShowAgain 
                  ? "✓ Diálogo desactivado" 
                  : "No volver a mostrar este mensaje"}
              </Typography>
              {dontShowAgain && (
                <Typography variant="caption" style={{ color: "#94a3b8" }}>
                  Desmarca para reactivar
                </Typography>
              )}
            </Box>
          }
        />
        <Box>
          <Button onClick={handleClose} color="default" style={{ marginRight: 8 }}>
            Cerrar
          </Button>
          <Button
            onClick={handleContinue}
            variant="contained"
            color="primary"
            startIcon={<PhotoCamera />}
          >
            Entendido, Continuar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default InformativeDialog;